import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { whoAmI } from '@/services/authService';
import { invalidateDevice, listDevices, setPassword, updateName } from './api';

export const settingsKeys = {
  devices: ['settings', 'devices'] as const,
};

export function useUpdateName() {
  return useMutation({
    mutationFn: (v: { profileId: string; firstName: string; lastName: string }) =>
      updateName(v.profileId, v.firstName, v.lastName),
    // The header shows the name from who-am-i.
    onSuccess: () => whoAmI(),
  });
}

export function useSetPassword() {
  return useMutation({ mutationFn: (v: { userId: string; password: string }) => setPassword(v.userId, v.password) });
}

export function useDevices() {
  return useQuery({ queryKey: settingsKeys.devices, queryFn: ({ signal }) => listDevices(signal) });
}

export function useInvalidateDevice() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => invalidateDevice(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: settingsKeys.devices }),
  });
}
